import useQueryStringState from "components/hooks/useQueryStringState";
import { PageHeader } from "components/ui/atoms/FormHeader";
import Layout from "components/ui/molecules/Layout";
import { useLogHistory } from "models/history/apiHistory";
import { useGetNote } from "models/notes/apiNote";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ModelNoteFormWithView } from "./NoteForm";
import NoteHeader from "./NoteHeader";

const NoteDetail = ({}) => {
  const { note_id } = useParams();
  const navigate = useNavigate();
  const [pageState, setPageState] = useQueryStringState({});
  const {
    data: note,
    isLoading: noteIsLoading,
    error,
    isError,
    isSuccess,
  } = useGetNote(note_id);

  const handleLog = useLogHistory("notes.note");

  useEffect(() => {
    isSuccess && handleLog(note.id);
  }, [isSuccess, note?.id]);

  const setMode = (mode) => {
    if (mode !== "view") {
      setPageState((prevState) => ({
        ...prevState,
        mode: mode,
      }));
    } else {
      setPageState((prevState) => {
        const { mode, ...rest } = prevState;
        return rest;
      });
    }
  };

  if (isError) {
    return <>{error.message}</>;
  }

  return (
    !noteIsLoading && (
      <Layout container hideBreadcrumbs>
        <Layout title variant="component">
          <PageHeader>
            <NoteHeader note={note} />
          </PageHeader>
        </Layout>
        <Layout content sx={{ p: 0 }}>
          <ModelNoteFormWithView
            objectId={note_id}
            onCancel={() => navigate(-1)}
            onDeleted={() => navigate("/note")}
            hideHeader={true}
            mode={pageState.mode || "view"}
            onModeChange={setMode}
          />
        </Layout>
      </Layout>
    )
  );
};

export default NoteDetail;
